<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-19 14:47:43
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			size="700px"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<div class="pos-rela ml-12 flex-1">
					<el-input placeholder="请输入集合页名称" v-model="form.title" clearable></el-input>
					<el-button class="searchBtn" @click="search()">搜索</el-button>
				</div>
				<!-- 弹窗内容部分 -->
				<el-table
					class="mt-24"
					:data="list"
					header-row-class-name="table-header-row"
					row-class-name="table-row"
					v-loading="loading"
					@row-click="rowClick"
				>
					<el-table-column label="集合页名称" prop="partner_commission_fee">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center">
								<el-radio v-model="id" :label="row.id">{{ '' }}</el-radio>
								<div>
									<el-tooltip placement="top" :content="row.bannerName" v-ak-tooltip-auto-show>
										<p class="line-ellipsis-1 yx-color-pure-1 font-h4-regular" style="width: 100%">{{ row.title }}</p>
									</el-tooltip>
									<p class="yx-color-pure-1 font-h6-medium">ID：{{ row.id }}</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="banner图" prop="partner_commission_fee" width="120">
						<template slot-scope="{ row }">
							<img
								v-if="row.imageUrl"
								style="width: 100px; height: 36px"
								class="radius-4 cursor-pointer"
								:src="row.imageUrl"
								alt=""
								@click.stop="openPreview(row.imageUrl)"
							/>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="关联资源位数" prop="partner_commission_fee" width="120">
						<template slot-scope="{ row }">
							<span class="yx-color-pure-1 font-h6-regular">{{ row.linkCount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="关联商品组" prop="partner_commission_fee" width="120">
						<template slot-scope="{ row }">
							<el-tooltip placement="top" :content="row.groupTitle" v-ak-tooltip-auto-show>
								<p class="line-ellipsis-1 yx-color-primary font-h4-regular cursor-pointer" style="width: 100%" @click.stop="skipGroup(row)">{{
									row.groupTitle
								}}</p>
							</el-tooltip>
							<p class="yx-color-pure-1 font-h6-medium">ID：{{ row.link }}</p>
						</template>
					</el-table-column>
					<el-table-column label="有效商品数" prop="partner_commission_fee" width="110">
						<template slot-scope="{ row }">
							<span class="yx-color-pure-1 font-h6-regular">{{ row.productNum }}</span>
						</template>
					</el-table-column>
				</el-table>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page"
					:page-size="pageInfo.pageSize"
					@size-change="sizeChange"
					@current-change="currentChange"
				></yx-pagination>
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="btnLoading">确认</el-button>
			</div>
			<previewImg ref="previewImg">
				<img style="width: 1200px" slot="introductionImg" :src="previewImg" alt="" />
			</previewImg>
		</el-drawer>
	</div>
</template>
<script>
import previewImg from '@/components/ui/previewImg';
import { productGatherList } from '@/api/selectionDecoration';
export default {
	components: {
		previewImg,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	computed: {},
	data() {
		return {
			title: '选择集合页', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			pageInfo: {
				page: 1, // 页码
				pageSize: 20, // 每页条数
			},
			form: {
				title: '',
			},
			loading: false, // 表格加载状态
			btnLoading: false, // 按钮loading
			id: 0,
			previewImg: '',
			index: 0,
		};
	},

	created() {
		this.initData();
	},
	methods: {
		// 主动显示弹窗
		show(id = 0, index = 0) {
			this.index = index; //回填数组
			this.id = id;
			this.visible = true;
			this.getList();
		},
		// 获取表格列表数据
		async getList() {
			const { platformId } = this;
			// 列表loading状态开启
			this.loading = true;
			try {
				const { list, page } = await productGatherList({ platformId, ...this.form, ...this.pageInfo, isPull: '1' });
				this.list = list;
				this.total = `${page.itemTotal}`;
			} catch (error) {
				this.list = [];
				this.total = 0;
			} finally {
				// 列表loading状态关闭
				this.loading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.id = 0;
			this.pageInfo = {
				page: 1,
				pageSize: 20,
			};
			this.previewImg = '';
			this.form = {
				title: '',
			};
			this.loading = false;
			this.btnLoading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm() {
			// 按钮loading开启
			this.btnLoading = true;
			try {
				// 刷新列表（外部重新获取数据）
				const data = this.list.find(item => item.id === this.id);
				const { id: gatherId, title: bannerTitle } = data;
				this.$emit('confirmAddCollection', { gatherId, bannerTitle }, this.index);
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading开启
				this.btnLoading = false;
			}
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.pageInfo.pageSize = val;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.pageInfo.page = val;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		openPreview(src) {
			this.previewImg = src;
			this.$refs.previewImg.show();
		},
		skipGroup({ link }) {
			const { platformId } = this;
			const handLink = this.$router.resolve({
				path: '/shopManage/shopGroup/detail/list',
				query: {
					groupId: link,
					platformId,
				},
			});
			window.open(handLink.href, '_blank');
		},
		rowClick({ id }) {
			this.id = id;
		},
		search() {
			this.getList();
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.searchBtn {
	width: 70px;
	background-color: @color-primary;
	color: #ffffff;
	font-size: 13px;
	border-top-left-radius: 2px;
	border-bottom-left-radius: 2px;
	position: absolute;
	right: 0;
	top: 0px;
	border: 1px solid @color-primary;
}
.content {
	::v-deep .el-radio {
		margin-right: 10px;
	}
}
.drawer-footer {
	background-color: #fff;
	z-index: 999;
}
</style>
